import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './DeleteAccount.css';

function DeleteAccount() {
  const [step, setStep] = useState(1);
  const [contactMethod, setContactMethod] = useState('');
  const [contactValue, setContactValue] = useState('');
  const [otp, setOtp] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);

  const handleSendOTP = (e) => {
    e.preventDefault();
    if (contactValue) {
      setStep(2);
    }
  };

  const handleVerifyOTP = (e) => {
    e.preventDefault();
    if (otp.length === 6) {
      setIsDeleted(true);
    }
  };

  if (isDeleted) {
    return (
      <div className="delete-account">
        <div className="container">
          <div className="back-nav">
            <Link to="/" className="back-btn">← Back to Home</Link>
          </div>
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h1>Account Deleted Successfully</h1>
            <p>Your SpendsMate account has been permanently deleted. All your data has been removed from our servers.</p>
            <p>We're sorry to see you go. If you change your mind, you can always create a new account.</p>
            <Link to="/" className="home-btn">Return to Home</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="delete-account">
      <div className="container">
        <div className="back-nav">
          <Link to="/" className="back-btn">← Back to Home</Link>
        </div>
        
        <div className="delete-form-container">
          <div className="warning-header">
            <div className="warning-icon">⚠️</div>
            <h1>Delete Account</h1>
            <p>This action cannot be undone. All your data will be permanently deleted.</p>
          </div>

          {step === 1 && (
            <form onSubmit={handleSendOTP} className="delete-form">
              <h2>Step 1: Verify Your Identity</h2>
              
              <div className="contact-method">
                <label>
                  <input
                    type="radio"
                    name="method"
                    value="email"
                    checked={contactMethod === 'email'}
                    onChange={(e) => setContactMethod(e.target.value)}
                  />
                  Email Address
                </label>
                <label>
                  <input
                    type="radio"
                    name="method"
                    value="phone"
                    checked={contactMethod === 'phone'}
                    onChange={(e) => setContactMethod(e.target.value)}
                  />
                  Phone Number
                </label>
              </div>

              {contactMethod && (
                <div className="input-group">
                  <label>
                    {contactMethod === 'email' ? 'Enter your email address:' : 'Enter your phone number:'}
                  </label>
                  <input
                    type={contactMethod === 'email' ? 'email' : 'tel'}
                    value={contactValue}
                    onChange={(e) => setContactValue(e.target.value)}
                    placeholder={contactMethod === 'email' ? 'your@email.com' : '+91 9876543210'}
                    required
                  />
                </div>
              )}

              <button type="submit" className="send-otp-btn" disabled={!contactValue}>
                Send OTP
              </button>
            </form>
          )}

          {step === 2 && (
            <form onSubmit={handleVerifyOTP} className="delete-form">
              <h2>Step 2: Enter OTP</h2>
              <p>We've sent a 6-digit OTP to your {contactMethod}: <strong>{contactValue}</strong></p>
              
              <div className="input-group">
                <label>Enter OTP:</label>
                <input
                  type="text"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                  placeholder="123456"
                  maxLength="6"
                  required
                />
              </div>

              <div className="form-actions">
                <button type="button" onClick={() => setStep(1)} className="back-step-btn">
                  Back
                </button>
                <button type="submit" className="delete-btn" disabled={otp.length !== 6}>
                  Delete Account
                </button>
              </div>
            </form>
          )}

          <div className="deletion-info">
            <h3>What will be deleted:</h3>
            <ul>
              <li>All your expense records and transaction history</li>
              <li>Your profile information and settings</li>
              <li>All group memberships and shared expenses</li>
              <li>Cashback history and pending rewards</li>
              <li>All app data and preferences</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteAccount;